import { render } from "./bottomParts.vue?vue&type=template&id=2250930d&scoped=true"
import script from "./bottomParts.vue?vue&type=script&lang=js"
export * from "./bottomParts.vue?vue&type=script&lang=js"

import "./bottomParts.vue?vue&type=style&index=0&id=2250930d&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2250930d"]])

export default __exports__